import { useCallback } from 'react';
import { Command } from 'pos/common';
import { CustomerDisplay } from 'pos/services';
import * as SalesStore from '../SalesStore';
import { SoldProductType, ProductForSaleDTO } from 'core/api';
import { Result } from 'core/infrastructure';
import * as Selection from './ProductSelectionState';
import { useOverlayExecutor } from 'core/ui-next/modal';

export function useProductComposer({ selection, setSelection }: { selection: Selection.ProductsSelection, setSelection: (selection: Selection.ProductsSelection) => void }) {

	const { execute } = useOverlayExecutor();

	const composeProduct = useCallback(
		async (product: ProductForSaleDTO, quantity?: number): Promise<Result> => {
			if (product.IsMenu) {
				return await execute({
					overlay: 'on-start',
					action: async () => {
						const result = await Command.execute('composeProduct', product, quantity);
						if (!result.ok) return Result.error();

						await SalesStore.addLine(result.value[0]);
						await CustomerDisplay.displayNewLine(SalesStore.getTicket(), SalesStore.getTicket().Lines.last());

						const menuHeader = SalesStore.getTicket().Lines
							.sortBy(x => x.Id)
							.reverse()
							.find(
								x =>
									x.Product.SaleFormatId === result.value[0].product.SaleFormatId &&
									x.Type === SoldProductType.MenuHeader
							);

						if (!menuHeader) return Result.ok();

						return await Command.execute('composeMenu', menuHeader, 'new');
					}
				});
			}

			if (product.IsSubFamily || product.IsSubCategory) {
				if (!selection.selectedGroup)
					throw new Error('No deberíamos llegar a una subfamilia sin grupo seleccionado');

				setSelection(await Selection.selectSubGroup(selection, product, SalesStore.getTicket().Id));
				return Result.ok();
			}

			const result = await execute({
				overlay: 'on-first-request',
				action: () => Command.execute('composeProduct', product, quantity, undefined),
			});

			if (!result.ok) return Result.error();

			await SalesStore.addLines(result.value);
			await CustomerDisplay.displayNewLine(SalesStore.getTicket(), SalesStore.getTicket().Lines.last());

			return result;
		},
		[execute, selection, setSelection]
	);

	return { composeProduct };
}